import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { GasprecioService } from 'src/app/modules/gasprecio/services/gasprecio.service';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-cluster2',
  templateUrl: './select-cluster2.component.html',
  styleUrls: ['./select-cluster2.component.scss']
})
export class SelectCluster2Component implements OnInit, OnDestroy {

  @Input() name: any = 'Estrategia';
  @Input() clusterImput: any = '';
  public items: any[] = [
    { name: 'Sin Filtro', value: null }
  ];
  public cluster: any = [];
  public ngxDisabled = true;
  idGroup$: Subscription;
  idGroup;
  selectedClusterId: string | null = null;
  selectedClusterValue: number | null = null;
  selectedClusterId$: Subscription;
  selectedClusters$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private gasprecioService: GasprecioService,
    private sharedService: SharedService
  ) {
    setTimeout(() => {

      this.idGroup$ = sharedService.sharedGroup.subscribe((idGroup: string) => {
        if (idGroup !== this.idGroup) {
          this.idGroup = idGroup;
          this.getClusters();
        }
      });

      this.selectedClusters$ = this.sharedService.sharedSelectedComplementClusters2.subscribe(selectedClusters => {
        if (selectedClusters !== this.selectedClusterValue) {
          this.selectedClusterValue = selectedClusters;
          if (this.selectedClusterId === null || this.selectedClusterId === undefined) {
            this.syncSelectedClusterId();
          }
        }
      });

      this.selectedClusterId$ = this.sharedService.sharedSelectedComplementClusters2Id.subscribe(selectedClusterId => {
        if (selectedClusterId !== this.selectedClusterId) {
          this.selectedClusterId = selectedClusterId;
          if (this.selectedClusterId !== null && this.selectedClusterId !== undefined) {
            const clusterMeta = this.getClusterMetaFromId(this.selectedClusterId);
            if (clusterMeta) {
              this.selectedClusterValue = clusterMeta.value;
            }
          }
        }
      });

    }, 500);
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnInit(): void { }

  ngOnDestroy() {
    this.idGroup$.unsubscribe();
    this.selectedClusters$.unsubscribe();
    this.selectedClusterId$.unsubscribe();
  }

  getClusters() {
    this.items = [
      { name: 'Sin Filtro', value: null }
    ];
    this.gasprecioService.getClusters(this.idGroup, (this.clusterImput || 'clusters_2')).subscribe((data: any) => {
      data.map((group) => {
        this.items.push({ name: group['name'], value: group['_id'] });
      });
      this.ngxDisabled = false;
      if (this.selectedClusterId === null || this.selectedClusterId === undefined) {
        this.syncSelectedClusterId();
      }
    });
  }

  changeCluster(event: any) {
    // Handle "Sin Filtro" case (null value)
    if (event === null || event === undefined) {
      this.selectedClusterId = null;
      this.selectedClusterValue = null;
      this.sharedService.nextSelectedComplementClusters2 = this.selectedClusterValue;
      this.sharedService.nextSelectedComplementClusters2Id = this.selectedClusterId;
      return;
    }

    const clusterMeta = this.getClusterMetaFromId(event);
    if (!clusterMeta) {
      console.error('Valor no válido seleccionado:', event);
      return;
    }

    this.selectedClusterId = event;
    this.selectedClusterValue = clusterMeta.value;
    this.name = clusterMeta.name;
    this.sharedService.nextSelectedComplementClusters2 = this.selectedClusterValue;
    this.sharedService.nextSelectedComplementClusters2Id = this.selectedClusterId;
  }

  private getClusterMetaFromId(event: string): { value: number; name: string } | null {
    switch (event) {
      case '66b14ee831109f255befbede':
        return { value: 2, name: 'Margen' };
      case '66b14f2431109f255befbee6':
        return { value: 3, name: 'Volumen' };
      case '66c9521433432b1ebda5aca5':
        return { value: 1, name: '10T' };
      case '680016f5ff259e8ffae230b3':
        return { value: 1, name: 'Baja precios' };
      case '680016fcff259e8ffae230b4':
        return { value: 0, name: 'Resto' };
      case '695e955f246190b229c9c9e7':
        return { value: 4, name: 'Sin Jarachina' };
      default:
        return null;
    }
  }

  private syncSelectedClusterId(): void {
    if (this.selectedClusterValue === null || this.selectedClusterValue === undefined) {
      this.selectedClusterId = null;
      return;
    }

    const matchedItem = this.items.find((item) => {
      if (item.value === null || item.value === undefined) {
        return false;
      }
      const clusterMeta = this.getClusterMetaFromId(item.value);
      return clusterMeta?.value === this.selectedClusterValue;
    });

    this.selectedClusterId = matchedItem ? matchedItem.value : null;
  }
}
